// controls/url.js — version React Composant + JSON Schema native
import React, { useState, useEffect } from "react";
import CommonControls from "./inc/Common";

/**
 * Création d’un champ URL conforme JSON Schema draft 2020-12
 */
export function createUrlField() {
  return {
    type: "string",
    format: "uri",
    title: "Adresse web (URL)",
    pattern:
      "^(https?:\\/\\/)?([\\w.-]+)\\.([a-z\\.]{2,6})([\\/\\w\\-.?=%]*)*\\/?$",
    minLength: 0,
    maxLength: 255,
    "x-ui": "url",
    "x-inputMode": "url",
    "x-placeholder": "https://",
    "x-displayWidth": "",
  };
}

/**
 * Éditeur du champ URL (FieldEditor) — version composant React
 */
export function EditUrlField({ field, onChange }) {
  const [min, setMin] = useState(field.minLength ?? 0);
  const [max, setMax] = useState(field.maxLength ?? 255);
  const [pattern, setPattern] = useState(
    field.pattern ||
    "^(https?:\\/\\/)?([\\w.-]+)\\.([a-z\\.]{2,6})([\\/\\w\\-.?=%]*)*\\/?$"
  );
  const [placeholder, setPlaceholder] = useState(field["x-placeholder"] || "https://");
  const [displayWidth, setDisplayWidth] = useState(field["x-displayWidth"] || "");

  // 🔄 Synchronisation ascendante vers FormBuilder
  useEffect(() => onChange("minLength", min), [min]);
  useEffect(() => onChange("maxLength", max), [max]);
  useEffect(() => onChange("pattern", pattern), [pattern]);
  useEffect(() => onChange("x-placeholder", placeholder), [placeholder]);
  useEffect(() => onChange("x-displayWidth", displayWidth), [displayWidth]);

  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      {/* ---- Longueurs ---- */}
      <div className="mb-3">
        <label className="form-label">Longueur minimale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 5"
          value={min}
          onChange={(e) => setMin(Number(e.target.value))}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Longueur maximale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 255"
          value={max}
          onChange={(e) => setMax(Number(e.target.value))}
        />
      </div>

      {/* ---- Motif (regex) ---- */}
      <div className="mb-3">
        <label className="form-label">Motif de validation (regex)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : ^https?://"
          value={pattern}
          onChange={(e) => setPattern(e.target.value)}
        />
        <small className="text-muted">
          Optionnel — pour restreindre le format autorisé (regex JavaScript).
        </small>
      </div>

      {/* ---- Placeholder ---- */}
      <div className="mb-3">
        <label className="form-label">Texte indicatif (placeholder)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : https://exemple.fr"
          value={placeholder}
          onChange={(e) => setPlaceholder(e.target.value)}
        />
      </div>

      {/* ---- Largeur visuelle ---- */}
      <div className="mb-3">
        <label className="form-label">Largeur du champ (en caractères)</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 60"
          value={displayWidth}
          onChange={(e) => setDisplayWidth(e.target.value)}
        />
      </div>
    </>
  );
}

/**
 * Compatibilité avec le FieldEditorRegistry
 */
export const editUrlField = (props) => <EditUrlField {...props} />;

/* =========================================================
   🧩 FRONT — rendu du champ URL
   ========================================================= */
export const RenderUrlField = ({
  field,
  value,
  onChange,
  className,
  errorMessage   // <--- AJOUT
}) => {

  const placeholder = field["x-placeholder"] || "https://";
  const inputMode = field["x-inputMode"] || "url";
  const displayWidth = field["x-displayWidth"] || "";
  const minLength = field.minLength ?? 0;
  const maxLength = field.maxLength ?? 255;
  const pattern =
    field.pattern ||
    "^(https?:\\/\\/)?([\\w.-]+)\\.([a-z\\.]{2,6})([\\/\\w\\-.?=%]*)*\\/?$";
  const required = field.required || false;

  return (
    <div
      className={`
        fb-field fb-url
        ${field["x-bloc-class"] || ""}
        ${className || ""}
      `}
    >

      {/* Label */}
      {field.title && (
        <label className={`form-label ${errorMessage ? "text-danger" : ""}`}>
          {field.title} {required && <span className="text-danger">*</span>}
        </label>
      )}

      {/* Input URL */}
      <input
        type="url"
        className={`
          form-control
          ${field["x-control-class"] || ""}
          ${errorMessage ? "is-invalid" : ""}
        `}
        placeholder={placeholder}
        inputMode={inputMode}
        pattern={pattern}
        minLength={minLength}
        maxLength={maxLength}
        size={displayWidth || undefined}
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
      />

      {/* Message d’erreur */}
      {errorMessage && (
        <div className="invalid-feedback d-block mt-1">
          {errorMessage}
        </div>
      )}

    </div>
  );
};
